<template>
  <div class="cancellation-wrapper">
    <slot name="headlineBefore"></slot>
    <slot name="txtBefore"></slot>
    <CancellationForm v-if="showCancellationForm">
      <template v-for="slot in possibleChildSlotsFor('Form')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </CancellationForm>
    <CancellationSuccess v-if="showCancellationSuccess">
      <template v-for="slot in possibleChildSlotsFor('Success')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </CancellationSuccess>
    <slot name="txtAfter"></slot>
  </div>
</template>

<script>
import CancellationForm, { stepName as formStepName } from './CancellationForm.vue'
import CancellationSuccess, { stepName as successStepName } from './CancellationSuccess.vue'
import { mapGetters } from 'vuex'
import slotProxy from '@/mixins/slotProxy'
import transaction from '@/mixins/transaction'

export default {
  name: 'CancellationWrapper',
  components: {
    CancellationSuccess,
    CancellationForm
  },
  mixins: [
    slotProxy(),
    transaction('cancellationForm')
  ],
  computed: {
    showCancellationForm () {
      return this.getStep === formStepName
    },
    showCancellationSuccess () {
      return this.getStep === successStepName
    },
    ...mapGetters('cancel', ['getStep'])

  },
  methods: {}
}
</script>
